import {
  BrandPowerStations,
  PowerStation,
  PowerStationInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

const brand = "Goal Zero";
const rawData: PowerStationInternal[] = [
  {
    name: "Yeti 700",
    amazon: {
      href: "https://www.amazon.com/dp/B0CRCVKNHR/",
      affiliate: "https://amzn.to/41yK4u0",
    },
    img: "/images/products/goal-zero/yeti-700/front.webp",

    price: 699.95,
    capacity: 677,
    acOutput: 600,
    dcOutput: 13.5,
    solar: 200,

    displayPowerSystemsPage: true,
  },

  //https://goalzero.com/collections/mid-size-power-stations/products/new-yeti-1000-portable-power-station-lfp-battery

  // High DC
  {
    name: "Yeti PRO 4000",
    amazon: {
      href: "https://www.amazon.com/dp/B0CJCT1TC5/",
      affiliate: "https://amzn.to/4vuNmvX",
    },
    img: "/images/products/goal-zero/yeti-pro-4000/front.webp",

    price: 3399.95,
    capacity: 3993.6,
    acOutput: 3600,
    dcOutput: 30,
    solar: 3000,

    expandable: true,

    displayPowerSystemsPage: true,
  },
  {
    name: "Yeti 1500",
    amazon: {
      href: "https://www.amazon.com/dp/B0GMKKGQCY/",
      affiliate: "https://amzn.to/4mrUFQO",
    },
    img: "/images/products/goal-zero/yeti-1500/front.webp",

    price: 1499.95,
    capacity: 1505.28,
    acOutput: 2000,
    dcOutput: 30,
    solar: 600,
    solar2: 300,

    displayPowerSystemsPage: true,
  },
];

const powerStations: BrandPowerStations = {
  name: brand,
  powerStations: buildProductRecord<PowerStationInternal, PowerStation>(
    rawData,
    brand
  ),
};

export default powerStations;
